import {useEffect, useState} from 'react';

export default function useInitialLoading(time = 1) {
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setInitialLoading(false);
    }, time * 500);
  }, [setInitialLoading, time]);

  return {initialLoading};
}
